export const isMfLoginRoute = (path: string) => {
  return ["/login", "/change-password", "/recovery-password"].includes(path);
};
